import { getFileNameFromUrl } from '~/utils/misc';

import { baseApi } from '../baseApi/baseApi';

import { ARTIFACTS_API_TAGS } from './artifacts.constants';

export const artifactsApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // POST /projects/<projectId>/artifacts/
    createArtifact: builder.mutation({
      query: ({ projectId, file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `/projects/${projectId}/artifacts/`,
          method: 'POST',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        };
      },
    }),

    // GET /artifacts/<artifactId>/
    getArtifact: builder.query({
      query: ({ id }) => ({
        url: `/artifacts/${id}/`,
        method: 'GET',
      }),
      providesTags: (result, error, { id }) => [{ type: ARTIFACTS_API_TAGS.ARTIFACT_TAG, id }],
    }),

    // GET /<artifactUrl>/
    getArtifactByUrl: builder.query({
      queryFn: async ({ url }) => {
        const response = await fetch(url, { method: 'GET' });
        const blobFile = await response.blob();
        const fileName = getFileNameFromUrl(url);
        const { type } = blobFile;

        return {
          data: new File([blobFile], fileName, { type: type || 'application/octet-stream' }),
        };
      },
    }),
  }),
});

export const { useCreateArtifactMutation, useGetArtifactQuery, useLazyGetArtifactByUrlQuery } =
  artifactsApi;
